import { UserRole } from "tm-shared/types";

import { isManagerRole } from "@/utils/business/isManagerRole";

export interface CreateCustomTaskModalCapabilities {
    canUseConnectedAgentSchedule: boolean;
}

export const getCreateCustomTaskModalCapabilities = (
    role: UserRole,
): CreateCustomTaskModalCapabilities => ({
    canUseConnectedAgentSchedule: isManagerRole(role),
});
